import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
} from '@angular/core';

import { FlexTimeActivity, FlexTimeActivityInstance } from 'libs/domain';

import { ActivityCardFields, FtmSharedMessages } from '../../ftm-shared.constants';

const mapTeachers = (teachers: Map<string, string>): Array<{ value: string; label: string }> => {
  return Array.from(teachers.entries()).map(([key, value]) => {
    return {
      value: key,
      label: value,
    };
  });
};

@Component({
  selector: 'mg-ftm-activity-selector-list',
  templateUrl: './ftm-activity-selector-list.component.html',
  styleUrls: ['./ftm-activity-selector-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FtmActivitySelectorListComponent {
  @ContentChild('noResults', { read: TemplateRef })
  noResults: TemplateRef<any>;

  public MESSAGES = FtmSharedMessages;

  private _activities;

  @Input() selectedId: number;

  @Input() set activities(activities: Array<FlexTimeActivityInstance | FlexTimeActivity>) {
    this._activities = (activities || []).sort((a, b) => {
      // need to normalize name field since it could be template or instance here
      const aName = (a as any).flexTimePeriod
        ? (a as FlexTimeActivityInstance).flexTimeActivity?.name
        : (a as FlexTimeActivity).name;
      const bName = (b as any).flexTimePeriod
        ? (b as FlexTimeActivityInstance).flexTimeActivity?.name
        : (b as FlexTimeActivity).name;

      return aName.localeCompare(bName);
    });
  }
  @Input() activityCardFields: ActivityCardFields[];
  @Output() activitySelected: EventEmitter<FlexTimeActivityInstance | FlexTimeActivity> = new EventEmitter();

  get activities() {
    return this._activities;
  }

  public select(activity) {
    this.activitySelected.emit(activity);
  }
}
